import { type ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CraneReducer } from "./CraneReducer";

const CraneContext = createContext({
  state: CraneReducer.getInitialState(),
  actions: CraneReducer.actions,
});

export const useCraneContext = () => useContext(CraneContext);

export const CraneProvider = ({ children }: { children: ReactNode }) => {
  const [state, actions] = useComplexState({
    initialState: CraneReducer.getInitialState(),
    reducers: CraneReducer.caseReducers,
  });
  return (
    <CraneContext.Provider value={{ state, actions }}>
      {children}
    </CraneContext.Provider>
  );
};
